import { authPut } from './authMiddleware';

export const putPropertyPortfolio = (portfolioId) => {
    return authPut('/api/portfolio', portfolioId)
}